import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isAccountFetching, userRequiresAccountSetup } from 'selectors/account';

import Passthrough from 'components/common/Passthrough';
import LoadingPage from 'components/common/LoadingPage';
import AccountSetup from 'components/AccountSetup';

export const AccountSetupRequired = ({ children, fetching, requiresAccountSetup }) => {
  // show loader while loading user
  if (fetching) return <LoadingPage />;
  // return the AccountSetup component if the user needs it
  if (requiresAccountSetup) return <AccountSetup />;
  // passthrough otherwise
  return <Passthrough>{ children }</Passthrough>;
};

AccountSetupRequired.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.element]),
  fetching: PropTypes.bool,
  requiresAccountSetup: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    fetching: isAccountFetching(state),
    requiresAccountSetup: userRequiresAccountSetup(state),
  };
}

export default connect(mapStateToProps)(AccountSetupRequired);



// WEBPACK FOOTER //
// ./src/components/AccountSetup/AccountSetupRequired.js